import { useQuery } from '@tanstack/react-query';
import { Link, useRouteContext } from '@tanstack/react-router';
import { TopBar } from '@/components/shell';
import { trpc } from '@/lib/trpc';

const QUEUES: { key: keyof QueueShape; label: string; to: string; built: boolean }[] = [
  { key: 'awaitingUpload', label: 'Awaiting upload', to: '/analyse', built: true },
  { key: 'awaitingSnippet', label: 'Awaiting snippet', to: '/analyse', built: true },
  { key: 'confirming', label: 'Confirming', to: '/analyse', built: true },
  { key: 'awaitingTagging', label: 'Awaiting tagging', to: '/tagging', built: true },
  { key: 'awaitingApproval', label: 'Awaiting approval', to: '/approve', built: true },
  { key: 'scheduled', label: 'Scheduled', to: '/scheduled', built: true },
];
type QueueShape = { awaitingUpload: number; awaitingSnippet: number; confirming: number; awaitingTagging: number; awaitingApproval: number; scheduled: number };

/** The brand's queues at a glance: the counts behind every "Awaiting ..." tab. */
export function HomePage() {
  const { me } = useRouteContext({ from: '/_app' });
  const queues = useQuery(trpc.tenant.queues.queryOptions());
  const brand = me.active;
  return (
    <>
      <TopBar title="Queue" right={brand && <span className="chip acc">{brand.brandName}</span>} />
      <section className="content col">
        {queues.isPending && <div className="empty"><div className="spinner" aria-label="Loading" /></div>}
        {queues.isError && <div className="card pad error" role="alert">{queues.error.message}</div>}
        {queues.data && (
          <div className="qgrid">
            {QUEUES.map((q) => q.built ? (
              <Link key={q.key} to={q.to} className="qcard">
                <b className="mono">{queues.data[q.key]}</b>
                <span>{q.label}</span>
              </Link>
            ) : (
              <div key={q.key} className="qcard soon">
                <b className="mono">{queues.data[q.key]}</b>
                <span>{q.label}</span>
              </div>
            ))}
          </div>
        )}
        <p className="note">Each count opens its screen as the screens land: Upload, Tagging, Approve and Scheduled follow in the next phases.</p>
      </section>
    </>
  );
}
